import { Component, OnInit, OnDestroy, ɵLocaleDataIndex } from '@angular/core';
import { AstrolyticsService } from "../../_services/astrolytics.service";
import { AuthenticationService } from "../../_services/authentication.service";
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-compare-page',
  templateUrl: './compare-page.component.html',
  styleUrls: ['./compare-page.component.css']
})
export class ComparePageComponent implements OnInit, OnDestroy {

  protected userStoreId
  protected targetId

  constructor(private astrolyticsService: AstrolyticsService, private authenticationService: AuthenticationService, private route: ActivatedRoute) { }

  ngOnInit() {

    this.userStoreId = this.authenticationService.selectedStoreValue.id
    this.targetId = this.route.snapshot.queryParamMap.get("target");
  }
  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {
  }

}
